// extracted by mini-css-extract-plugin
export default {"wrap":"message-input_wrap__YgVyq","controls":"message-input_controls__sVGOe"};